import {decorate, observable} from 'mobx';
import {faFrown} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel as Hierarchy, BaseModel} from './base';

export class InterruptionReason extends BaseModel {
  static faIcon = faFrown;

  static prepareApiPayload(model) {
    return {
      id: model.id,
      name: model.name,
      isMessageRequired: Boolean(model.isMessageRequired),
      isQuickstop: Boolean(model.isQuickstop),
      quickstopDurationMinutes: model.isQuickstop ? Number(model.quickstopDurationMinutes) : null,
      sortOrder: this.hasSortOrder(model) ? model.sortOrder : null,
      reasonSourceId: model.reasonSourceId || null,
      hierarchyIds: model.hierarchyIds || [],
    };
  }

  populateAttributesFromStore(rootStore) {
    this.reasonSource = rootStore.interruptionReasonSourceStore.getById(this.reasonSourceId);
    this.hierarchies = this.hierarchyIds.map(
      (hierarchyId) => Hierarchy.findInTree(rootStore.hierarchyStore.hierarchies, hierarchyId)
    );

    return super.populateAttributesFromStore(rootStore);
  }

  static hasSortOrder(model) {
    return parseInt(model.sortOrder, 10) >= 0;
  }

  searchableProperties = ['name'];
}

decorate(InterruptionReason, {
  id: observable,
  name: observable,
  isMessageRequired: observable,
  isQuickstop: observable,
  quickstopDurationMinutes: observable,
  sortOrder: observable,
  hierarchyIds: observable,
  hierarchies: observable,
  reasonSourceId: observable,
  reasonSource: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
});
